<template>
  <div class="lucky-turn">
    <div class="lucky-title">
      <img src="@/assets/lucky/turntable/title_bg.png" alt="">
      <div class="title-content">
        <span class="title-header">元宵喜乐</span><br>
        <span>学堂低至5折起</span>
      </div>
    </div>
    <lucky-turntable :prizeList="prizeList" ref="turntable" @start="handleStart" @end="handleEnd"/>
    <div class="rule">
      <img src="@/assets/lucky/turntable/rule_bg.png" alt="">
      <div class="rule-container">
        <div class="title">活动规则</div>
        <ul class="desc">
            <li>1、2月25日-3月1日活动期间，用户每日有2次抽奖资格，当天如未使用，过期作废。</li>
            <li>2、抽中奖券仅当天有效，已抽中代金券可到“已购”-“我的优惠券”中查看。 </li>
            <li>3、如抽中多张同学科代金券不可叠加使用，在购买专辑付款时默认勾选。</li>
        </ul>
      </div>
    </div>
    <div class="alert-container" v-show="showAlert">
      <div class="alert-content">
        <img v-if="prize.prize_type == 0" src="@/assets/lucky/turntable/alert_welcome_bg.png" alt="">
        <img v-else src="@/assets/lucky/turntable/alert_success_bg.png" alt="">
        <div class="content">
          <img v-if="prize.prize_type == 0" src="@/assets/lucky/turntable/welcome_icon.png" alt="">
          <img v-else src="@/assets/lucky/turntable/voucher_icon.png" alt="">
          <div>{{ prize.prompt }}</div>
        </div>
        <div v-if="prize.prize_type == 1" class="button" @click.stop="receiveHandle">立即领取</div>
        <div v-else class="button" @click.stop="againHandle">再来一次</div>
        <img v-show="prize.prize_type != 1" class="close-btn" src="@/assets/lucky/turntable/close_icon.png" @click="showAlert=false">
      </div>
    </div>
    <div class="alert-container" v-show="showGradeAlert">
      <div class="alert-grade">
        <div class="title">选择你的年级</div>
        <div class="grade-container">
          <span v-for="(value, index) in prize.options" :key="index" :class="['grade-item', chooseOption==value?'active':'']" @click="chooseOption = value">{{ value }}</span>
        </div>
        <div class="button" @click="receive">领取</div>
      </div>
    </div>
  </div>
</template>

<script>
import LuckyTurntable from "@/components/LuckyTurntable"
import { tprizeInfo, tlottery, tReceive } from "@/api/lucky"
import { Toast } from 'mint-ui'
export default {
  name: 'Lucky',
  components: {
    LuckyTurntable
  },
  data() {
    return {
      prizeList: [],
      count: 3,
      index: -1,
      prize: {},
      showAlert: false,
      showGradeAlert: false,
      chooseOption: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      tprizeInfo().then((response)=>{
        this.prizeList = response.data.data
      })
    },
    handleStart() {
      tlottery().then((response)=>{
        this.prize = response.data.data
        for(var key in this.prizeList){
          if(this.prizeList[key].id == this.prize.id){
            this.index = key
            this.$refs.turntable.beginRotate(this.index)
            return
          }
        }
        // 弹出再接再厉的弹出框
        this.prize = {id: -1, prompt: '再接再厉'}
        this.showAlert = true;
      }).catch(error=>{
        if(error.message != 'Error'){
          this.$router.push({path: '/login', query: { scene: error.message==311?'bind':'login', redirect: this.$route.fullPath}})
        }
      })
    },
    handleEnd() {
      // 弹出中奖框
      this.showAlert = true;
    },
    againHandle() {
      this.showAlert = false;
      this.handleStart()
    },
    receiveHandle() {
      if(this.prize.options.length > 0){
        this.showAlert = false
        this.showGradeAlert = true
      }else {
        this.receive()
      }
    },
    receive() {
      if(this.prize.options.length > 0&&!this.chooseOption){
        Toast({
          message: '请选择年级',
          position: 'bottom',
          duration: 1000
        })
        return
      }
      tReceive({option: this.chooseOption}).then(()=>{
        this.showAlert = false
        this.showGradeAlert = false
        this.$router.push({path: this.prize.jump})
      }).catch(()=>{
        this.showAlert = false
        this.showGradeAlert = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.lucky-turn{
  background-color: #FCE2C5;
  min-height: 100vh;
  img{
    display: block;
    width: 100%;
  }
  .lucky-title{
    position: relative;
    .title-content{
      position: absolute;
      bottom: 4px;
      width: 100%;
      color: #FEFFEA;
      font-size: 19px;
      .title-header{
        font-size: 26px;
      }
    }
  }
  .rule{
    position: relative;
    color: #9D8964;
    .rule-container{
      position: absolute;
      width: 70vw;
      left: 15vw;
      top: 18vw;
      .title{
        color: #844534;
        font-size: 19px;
        margin-bottom: 10px;
      }
      .desc{
        text-align: left;
        font-size: 14px;
        li{
          list-style-type:none;
        }
      }
    }
  }
  .alert-container{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(5, 5, 5, 0.555);
    z-index: 10;
    .alert-content{
      margin: 0 auto;
      margin-top: calc(50vh - 60vw);
      color: #333;
      position: relative;
      .content{
        position: absolute;
        width: 50vw;
        top: 48vw;
        left: calc(50% - 25vw);
        text-align: center;
        color: #D1712C;
        font-size: 19px;
        img{
          display: inline-block;
          width: 50%;
        }
      }
      .button{
        position: absolute;
        top: 88vw;
        left: calc(50% - 20vw);
        background: url("~@/assets/lucky/turntable/alert_btn_bg.png") no-repeat center top;
        background-size: 100%;
        width: 40vw;
        height: 9vw;
        padding: 6px 0;
        color: #FEFFEA;
      }
      .close-btn{
        width: 10vw;
        margin: 0 auto;
      }
    }
    .alert-grade{
      width: 80vw;
      background-color: #fff;
      margin: 40vh auto 0 auto;
      border-radius: 10px;
      padding: 13px;
      color: #666;
      .title{
        position: relative;
        text-align: left;
        padding: 3px 0 0 6px;
        &::before{
          position: absolute;
          top: 0;
          left: 0;
          content: "";
          width: 16px;
          height: 16px;
          border-radius: 16px;
          background-image: linear-gradient(135deg, #FFB320, rgba(255, 177, 32, 0));
        }
      }
      .grade-container{
        display: flex;
        flex-wrap: wrap;
        padding: 6px 0;
        .grade-item{
          padding: 3px 19px;
          background: #F7F6F7;
          border-radius: 16px;
          margin: 3px 6px 3px 6px;
          &.active{
            color: #fff;
            background: linear-gradient(136deg, #FFCD26 0%, #FFAC1F 100%);
          }
        }
      }
      .button{
        padding: 6px 16px;
        background: linear-gradient(136deg, #FFCD26 0%, #FFAC1F 100%);
        border-radius: 32px;
        color: #fff;
      }
    }
  }
}
@media screen and (max-width: 370px){
  .lucky-turn{
    .lucky-title{
      .title-content{
        font-size: 16px;
        .title-header{
          font-size: 22px;
        }
      }
    }
    .rule{
      .rule-container{
        .title{
          margin-bottom: 3px;
        }
        .desc{
          font-size: 13px;
        }
      }
    }
  }
}
@media screen and (max-width: 320px){
  .lucky-turn{
    .lucky-title{
      .title-content{
        font-size: 16px;
        .title-header{
          font-size: 22px;
        }
      }
    }
    .rule{
      .rule-container{
        .title{
          margin-bottom: 3px;
        }
        .desc{
          font-size: 10px;
        }
      }
    }
  }
}
</style>
